import { Component } from '@angular/core';

@Component({
  selector: 'gt-register',
  templateUrl: './register.html',
  styleUrl: './register.scss',
})
export class RegisterPage {
  backgroundImageUrl = 'assets/img/register-background.jpg';
}
